export default {"src":"/_next/static/media/imageError.d7474c87.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};